import contentfulGql from 'js/lib/contentfulGql';

import { entWebsiteBlockAssemblyFragment } from 'bundles/ent-website/queries/EntWebsiteBlockAssembly';
import { imageFragment } from 'bundles/ent-website/queries/common';

export const entWebsitePartnerFragment = contentfulGql`#graphql
  ${imageFragment}
  fragment EntWebsitePartner on EntWebsitePartner {
    name
    slug
    logo {
      ...Image
    }
    description
  }
`;

export const entWebsitePartnerListFragment = contentfulGql`#graphql
  ${entWebsitePartnerFragment}
  fragment EntWebsitePartnerList on EntWebsitePartnerList {
    title
    slug
    tagline
    description
    ctaText
    ctaTarget
    partnersCollection(limit: 10) {
      items {
        ...EntWebsitePartner
      }
    }
  }
`;

export const entWebsiteBlockPartnerListQuery = contentfulGql`#graphql
  ${entWebsiteBlockAssemblyFragment}
  ${entWebsitePartnerListFragment}

  query entWebsiteBlockPartnerList($id: String!, $preview: Boolean, $locale: String!) {
    entWebsiteBlockAssembly(id: $id, preview: $preview, locale: $locale) {
      ...EntWebsiteBlockAssembly
      reference {
        __typename
        ...EntWebsitePartnerList
      }
    }
  }
`;
